import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import Blog from "./Blog/Blog";
import About from "./About/About";
import Recruit from "./Career/Recruit";
import BlogPost from "./Blog/BlogPost";
import Cookiepolicy from "./Cookiepolicy/Cookiepolicy";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <App />,
    },
    {
      path: "/blogs",
      element: <Blog />,
      children: [
        {
          path: "/blogs/:category",
          element: <Blog />,
        },
      ],
    },
    {
      path: "/about",
      element: <About />,
    },
    {
      path: "/cookiepolicy",
      element: <Cookiepolicy />,
    },
    {
      path: "/blogs/:category/:id",
      element: <BlogPost />,
    },
    {
      path: "/recruit",
      element: <Recruit />,
    },
  ],
  {
    basename: "/engineering",
  }
);

export default router;
